@import '../../../../../static/less/variables';

.c-slider {
  text-align: center;
  padding: 65px 0 92px;
  box-shadow: inset 0 3px 3px 0 rgba(207, 216, 227, 0.23);

  .c-line {
    margin: 0 0 20px;

    .c-line-arrow {
      margin: -95px auto auto;
    }
  }
}

.c-action {
  padding: 70px 0;

  > .btn-group {
    margin-left: 10px;
  }
}

.c-daily-block {
  padding-top: 60px;
  text-align: center;
  margin-left: -60px;

  h1 {
    margin-top: 10px;
    color: rgb(48, 48, 48);
    font-size: 38px;
    font-weight: 300;
    margin-bottom: 0;
  }

  .text-promo {
    font-size: 20px;
    color: #79818e;
    line-height: 1.111;
    text-align: center;
    max-width: 510px;
    margin: 32px auto auto;
  }

  .text-bullets {
    margin-top: 48px;

    img {
      display: block;
      margin: auto;
      max-width: 140px;
    }
  }

  .c-daily {
    text-align: center;
  }

  .c-daily-btn {
    .btn-md {
      padding: 15px 25px;
    }

    a {
      margin-right: 20px;
      margin-left: 20px;
    }
  }

  .c-line {
    margin: 70px 0 13px;
  }

  .c-daily-list {
    text-align: center;

    .c-daily-list-item {
      text-align: center;
      font-size: 20px;
      width: 16%;
      vertical-align: top;
      max-width: 220px;
      margin-left: 17px;
      margin-right: 17px;
    }
  }
}

.modal-sm {
  min-width: 550px;
}

.c-slider-area-buttons {
  margin-top: 170px;

  .btn-lg {
    min-width: 245px;
    padding: 16px 30px;
    font-size: 18px;
    font-weight: bold;
    border-color: #307bc7;
    margin-bottom: 15px;
  }

  .btn-link {
    font-size: 16px;
  }
}

.c-slider-area {
  font-size: 15px;
  color: @pipl-modal-subtext;
  font-weight: 600;
  min-height: 115px;
  padding-top: 70px;
  padding-right: 114px;
  padding-left: 80px;

  .rc-slider {
    margin-left: 15px;
    margin-top: 70px;
    margin-bottom: 80px;
  }

  .rc-slider-step {
    height: 10px;
  }

  .rc-slider-rail {
    background-color: #dee7ee;
    height: 6px;
  }

  .rc-slider-track {
    background-color: @pipl-blue;
    height: 6px;
  }

  .rc-slider-dot {
    background-color: #dee7ee;
    bottom: 0;
    width: 16px;
    height: 16px;
  }

  .rc-slider-dot-active {
    background-color: @pipl-blue;
    border-color: @pipl-blue;
  }

  .rc-slider-handle:hover {
    border-color: @pipl-blue;
  }

  .rc-slider-handle {
    width: 58px;
    height: 58px;
    margin-top: -26px;
    margin-left: -27px;
    border: 1px solid #d5dae0;
    box-shadow: 0 11px 14px 0 rgba(202, 215, 230, 0.72);
  }

  .slider-text {
    margin-top: -90px;
    font-size: 26px;
    font-weight: 500;
    color: #566274;

    .slider-bottom-text {
      margin-top: 95px;

      small {
        color: #474d56;
        display: block;
        font-size: 16px;
        font-weight: 300;
      }
    }
  }
}

.c-finished-icon {
  background: url('../../../assets/subscription_success.png') no-repeat;
  background-size: 100%;
  height: 140px;
  width: 140px;
  margin: auto;
}

.c-finished {
  display: inline;
  text-align: center;
  font-weight: 600;

  h2 {
    font-size: 26px;
    color: #000;
  }
}

@media screen and (max-width: @screen-sm-max) {
  .modal-sm {
    min-width: 94%;
    width: 94%;
    margin-left: 3%;
    .modal-title {
      font-size: 20px;
    }
  }

  .c-daily-block {
    margin-left: 0;
  }

  .c-daily-block .c-daily-btn .btn-md {
    width: 100%;
    margin: 0 0 10px 0;
  }

  .c-daily-block .c-daily-list .c-daily-list-item {
    margin: 0 0 20px 0;
    width: 50%;
    max-width: unset;
  }

  .c-slider-area {
    padding-right: 60px;
    padding-left: 5px;

    .slider-text {
      font-size: 23px;
    }
  }

  .c-slider-area .rc-slider-handle {
    width: 40px;
    height: 40px;
    margin-top: -17px;
    margin-left: -20px;
  }
}

@media screen and (max-width: @screen-xs-max) {
  .c-action {
    .btn-group {
      margin: 10px 0;
    }
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/DailyBlock/components/DailyBlockPage.less